var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#20CE86"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4703 51C30.7653 51 29.9722 50.9126 29.091 50.7378C26.3887 50.0386 24.3326 48.4364 22.9226 45.931C21.2777 46.5719 19.5741 46.7176 17.8117 46.368C15.9905 45.9602 14.4337 45.0279 13.1413 43.5713C11.5552 41.7652 10.8502 39.6677 11.0264 37.2788C11.1439 34.8318 12.1133 32.8217 13.9344 31.2485C14.5806 30.7242 15.2856 30.1124 16.0493 29.4132C16.7542 28.6558 17.5179 27.8984 18.3404 27.1409C19.7503 25.7426 21.219 24.3151 22.7464 22.8585C24.3326 21.4019 25.86 20.1201 27.3286 19.0131C28.3273 18.2557 29.2673 17.5857 30.1485 17.003C31.0884 16.4204 31.9696 15.9251 32.7921 15.5173C35.8469 14.0607 38.843 13.6528 41.7803 14.2937C45.1289 15.226 47.4494 17.3526 48.7418 20.6736C49.5643 23.0042 49.5349 25.4513 48.6537 28.0149C48.5362 28.3062 48.4187 28.5975 48.3012 28.8889C48.1837 29.1802 48.0368 29.5006 47.8606 29.8502C49.9755 30.8407 51.5029 32.4721 52.4429 34.7444C53.2653 37.0749 53.1772 39.3472 52.1785 41.5612C51.1798 43.717 49.5055 45.2027 47.1557 46.0184C45.3345 46.7176 43.6602 47.3585 42.1328 47.9411C40.6054 48.4655 39.313 48.9025 38.2555 49.2521C37.6681 49.4851 37.11 49.6891 36.5812 49.8638C36.1113 50.0386 35.7294 50.1843 35.4357 50.3008C34.8482 50.4174 34.2314 50.563 33.5852 50.7378C32.939 50.9126 32.234 51 31.4703 51Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignImage3);
export default __webpack_public_path__ + "static/media/sign-image3.83bc5f959db055a74340500a22fd0e32.svg";
export { ForwardRef as ReactComponent };